export default __webpack_public_path__ + "static/media/astrazeneca-logo.97e4b0e3.png";